import { Box, Flex } from '@mantine/core';
import { CardHeader } from '../Elements/CardHeader/CardHeader';
import { DisplayModalContent } from '@/components';
import { Button } from '@/components/Elements';

type ActionPopUpModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  displayContent: string | React.ReactNode;
  onAccept?: () => void;
  onReject?: () => void;
  acceptTitle?: string | null;
  rejectTitle?: string | null;
  children?: React.ReactNode;
  closeOnClickOutside?: boolean;
  showCloseIcon?: boolean;
  className?: string;
  divider?: boolean;
};

export const ActionPopUpModal = ({
  isModalOpen,
  setIsModalOpen,
  displayContent,
  acceptTitle,
  onAccept,
  rejectTitle,
  onReject,
  children,
  closeOnClickOutside = true,
  showCloseIcon,
  className,
  divider = false,
}: ActionPopUpModalProps) => (
  <DisplayModalContent
    title={
      <CardHeader
        title={displayContent}
        onClose={() => {
          setIsModalOpen(false);
        }}
        divider={divider}
        showCloseIcon={showCloseIcon}
      />
    }
    opened={isModalOpen}
    className={className}
    onClose={() => {
      setIsModalOpen(false);
    }}
    closeOnClickOutside={closeOnClickOutside}
  >
    <Box>
      {children ?? ''}
      <Flex gap="md">
        {(rejectTitle ?? onReject) && (
          <Button
            onClick={() => {
              if (onReject) onReject();
              setIsModalOpen(false);
            }}
            variant="light"
            fullWidth
            mt="lg"
          >
            {rejectTitle ?? 'No'}
          </Button>
        )}

        {(acceptTitle ?? onAccept) && (
          <Button
            fullWidth
            mt="lg"
            onClick={() => {
              if (onAccept) onAccept();
              setIsModalOpen(false);
            }}
          >
            {acceptTitle ?? 'Yes'}
          </Button>
        )}
      </Flex>
    </Box>
  </DisplayModalContent>
);
